import React from 'react';
import { scoreToGrade, pointsToNextGrade } from '../utils/GradeUtils';

interface GradeProgressBarProps {
  score: number;
  compact?: boolean;
}

const GradeProgressBar: React.FC<GradeProgressBarProps> = ({ score, compact = false }) => {
  const { grade, color } = scoreToGrade(score);
  const next = pointsToNextGrade(score);

  return (
    <div className={compact ? '' : 'w-full'}>
      {/* Score + Grade label */}
      <div className="flex items-baseline justify-between mb-1.5">
        <div className="flex items-baseline gap-2">
          <span className={`${compact ? 'text-lg' : 'text-2xl'} font-light`} style={{ color }}>
            {score}%
          </span>
          <span className={`${compact ? 'text-xs' : 'text-sm'} font-medium`} style={{ color }}>
            {grade}
          </span>
        </div>
        {next && (
          <span className={`${compact ? 'text-[9px]' : 'text-xs'} text-white/40`}>
            {next.points} more to {next.nextGrade}
          </span>
        )}
      </div>

      {/* Progress bar */}
      <div className={`${compact ? 'h-1.5' : 'h-2'} bg-white/[0.04] rounded-full overflow-hidden`} role="progressbar" aria-valuenow={score} aria-valuemin={0} aria-valuemax={100} aria-label={`Compliance score: ${score}%`}>
        <div
          className="h-full rounded-full transition-all duration-1000 ease-out"
          style={{
            width: `${score}%`,
            background: `linear-gradient(90deg, ${color}90, ${color})`,
            boxShadow: `0 0 8px ${color}40`,
          }}
        />
      </div>
    </div>
  );
};

export default GradeProgressBar;
